var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { CountryStatesIndraService } from '@ibe.services/country-states-indra.service';
import * as fromActions from '../actions/country-state.actions';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
var CountryStateEffects = /** @class */ (function () {
    function CountryStateEffects(actions$, service) {
        var _this = this;
        this.actions$ = actions$;
        this.service = service;
        this.loadCountryCodes$ = this.actions$.pipe(ofType(fromActions.ActionTypes.LOAD_COUNTRY_CODES), switchMap(function () { return _this.service.getCountryCodes(); }), map(function (data) { return new fromActions.LoadCountryCodesSuccess(data); }));
        this.loadCountryConversionCodes$ = this.actions$.pipe(ofType(fromActions.ActionTypes.LOAD_COUNTRY_CONVERSION_CODES), switchMap(function () { return _this.service.getCountryConversionCodes(); }), map(function (data) { return new fromActions.LoadCountryConversionCodesSuccess(data); }));
        this.loadUSAirports$ = this.actions$.pipe(ofType(fromActions.ActionTypes.LOAD_US_AIRPORTS), switchMap(function () { return _this.service.getUSAirports(); }), map(function (data) { return new fromActions.LoadUSAirportsSuccess(data); }));
        this.loadUSStates$ = this.actions$.pipe(ofType(fromActions.ActionTypes.LOAD_US_STATES), switchMap(function () { return _this.service.getUSStates(); }), map(function (data) { return new fromActions.LoadUSStatesSuccess(data); }));
        this.loadSchengenCountryCodes$ = this.actions$.pipe(ofType(fromActions.ActionTypes.LOAD_SCHENGEN_COUNTRY_CODES), switchMap(function () { return _this.service.getSchengenCountryCodes(); }), map(function (data) { return new fromActions.LoadSchengenCountryCodesSuccess(data); }));
        this.loadEUCountryCodes$ = this.actions$.pipe(ofType(fromActions.ActionTypes.LOAD_EU_COUNTRY_CODES), switchMap(function () { return _this.service.getEUCountryCodes(); }), map(function (data) { return new fromActions.LoadEUCountryCodesSuccess(data); }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CountryStateEffects.prototype, "loadCountryCodes$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CountryStateEffects.prototype, "loadCountryConversionCodes$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CountryStateEffects.prototype, "loadUSAirports$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CountryStateEffects.prototype, "loadUSStates$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CountryStateEffects.prototype, "loadSchengenCountryCodes$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CountryStateEffects.prototype, "loadEUCountryCodes$", void 0);
    return CountryStateEffects;
}());
export { CountryStateEffects };
